'use strict';

angular.module('imagetrend.components')
    .directive('hlpFormGroup', ['$rootScope', function ($rootScope) {
        return {
            restrict: 'AE',
            scope: {
                group: '=?',
                initializeAnswers: '&',
                parameters: '=?',
                checkboxOrRadio: '=?',
                resultSet: '=?',
                deficiencies: '=?',
                pdf: '=?',
                datapointAnswers: '=?',
                completed: '=?',
                saving: '=?',
                deficiencyScore: "=?",
                inspectionChecklist: "=?",
                defaultGroup: "=?",
                groups: "=?"
            },
            replace: true,
            transclude: true,
            templateUrl: 'templates/form-builder-form/form-group/form-group.html',
            link: function (scope, elem, attrs, ctrl) {
                scope.getDocumentURL = function (component) {
                    if ($rootScope.isPortal && $rootScope.isPortal == "True") {
                        return $rootScope.portalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + component.document_id.toUpperCase() + '&code=' + component.document_code;
                    }
                    else {
                        return $rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument' + '&documentID=' + component.document_id.toUpperCase() + '&code=' + component.document_code;
                    }
                }

                scope.checkIfImageOrPDF = function (component) {
                    if (component.document_file_name) {
                        var extensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'pdf'];
                        return extensions.includes(component.document_file_name.split('.').pop().toLowerCase());
                    }
                    return false;
                };

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).off(); // deregister all event handlers
                        angular.element(elem).remove();
                        elem = null;
                    }
                });         
            }
        };
    }])
;